import {
  compactFormat,
  dataLabelsCompact,
  dataLabelsDecimals,
  dataLabelsSizes,
  granularity,
  legendPosition,
  lineThickness,
  palette,
  showDataLabels,
} from "@/settings/charts/settingsDictionary";
import { FAMILY } from "@/settings/widgetFamilies";
import { Config } from "@/types/charts";

export default <Config>{
  family: [FAMILY.OVERTIME],
  recommendedFamily: [FAMILY.OVERTIME],
  name: "yearOverYearLineChart",
  title: "Year Over Year Line Chart",
  defaultHeight: 6,
  controls: [granularity],
  settings: {
    palette,
    lineThickness: { ...lineThickness, gridPosition: [2, 0] },
    legendPosition: { ...legendPosition, gridPosition: [3, 0] },
    compactFormat: { ...compactFormat, gridPosition: [4, 0] },
    xAxis: {
      default: "month",
      type: "select",
      label: "Horizontal Axis Metric",
      dictionary: "timeMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    yAxisPrimary: {
      default: "spend",
      type: "select",
      label: "Vertical Axis Metric",
      dictionary: "displayMetrics",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },
    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [0, 1],
      forAxis: "xAxis",
    },
    yAxisPrimaryTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [1, 1],
      forAxis: "yAxisPrimary",
    },
  },
  planSettings: {
    palette,
    lineThickness: { ...lineThickness, gridPosition: [2, 0] },
    legendPosition: { ...legendPosition, gridPosition: [3, 0] },
    compactFormat: { ...compactFormat, gridPosition: [4, 0] },
    showDataLabels: { ...showDataLabels, gridPosition: [5, 0] },
    dataLabelsSizes: { ...dataLabelsSizes, gridPosition: [5, 1] },
    dataLabelsCompact: { ...dataLabelsCompact, gridPosition: [6, 0] },
    dataLabelsDecimals: { ...dataLabelsDecimals, gridPosition: [6, 1] },
    xAxis: {
      default: "month",
      type: "select",
      label: "Horizontal Axis Metric",
      dictionary: "timeMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    yAxisPrimary: {
      default: "channel_budget",
      type: "select",
      label: "Vertical Axis Metric",
      dictionary: "displayMetrics",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },
    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [0, 1],
      forAxis: "xAxis",
    },
    yAxisPrimaryTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [1, 1],
      forAxis: "yAxisPrimary",
    },
  },
};
